<template>
    <div>
        <h1>
            Редактировать место
        </h1>
        <transfer-places-update-form />
    </div>
</template>

<script>
import TransferPlacesUpdateForm from '@/modules/transfer/components/TransferPlacesUpdateForm';

export default {
    name: 'TransferPlacesUpdateView',
    components: { TransferPlacesUpdateForm }
};
</script>

<style scoped>

</style>
